import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, Dropdown, Alert, Layout, Menu, Row, Col, Button, Space, message, Empty, Spin, Tag } from "antd";
import { LeftOutlined, RightOutlined, NodeIndexOutlined, RiseOutlined, DashboardOutlined, ThunderboltOutlined, HeartOutlined, CompassOutlined, StarOutlined, ClockCircleOutlined } from "@ant-design/icons";

import moment from "moment";
import _ from "lodash";

import ReactEcharts from "echarts-for-react";
import {
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILTER_DATE_RANGES,
  FILE_TYPE,
  VIEW_TYPE,
  SPORT_TYPE,
  BAR_CHART_OPTION,
  CHART_COLOR_OPTION
} from "constants/index";

import { AppContext } from "contexts/AppContext";

const BarChart = ({ chartTitle, chartData, chartKeyData, chartColor, chartHeight, pageView }) => {
  const appContext = useContext(AppContext);

  const buildChart = (data) => {
    const option = _.cloneDeep(BAR_CHART_OPTION);
    option.legend.show = false;
    option.xAxis.show = true;
    option.xAxis.axisLabel = {
      show: true,
      rotate: 0,
      formatter: function (value, index) {
        return moment(value).format("MM");
      },
    };
    option.xAxis.data = _.uniqBy(data, "date").map((item, index) => {
      return item.date;
    });
    if (pageView === VIEW_TYPE.Year) {
      option.tooltip = {
        trigger: 'axis',
        axisPointer: {
          type: "shadow",
        },
        textStyle: {
          fontSize: 12
        },
        formatter: function (values) {
          let htmlTooltip = `${moment(values[0].name).format(DATE_TIME_FORMAT.MONTH)}<br />`;
          for (let s of values) {
            if (s.seriesName === "Distance") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Distance}; margin-right: 8px;">&nbsp;</span>${(s.data.value / 1000).toFixed(1)} km<br />`;
            else if (s.seriesName === "Speed" || s.seriesName === "Pace") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Pace}; margin-right: 8px;">&nbsp;</span>${s.data.pace}<br />`;
            else if (s.seriesName === "Elevation") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Elevation}; margin-right: 8px;">&nbsp;</span>${s.data.value} m<br />`;
            else if (s.seriesName === "Power") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Power}; margin-right: 8px;">&nbsp;</span>${s.data.value} watts<br />`;
            else if (s.seriesName === "Days Active") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.DaysActive}; margin-right: 8px;">&nbsp;</span>${s.data.value} days<br />`;
            else if (s.seriesName === "HR") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.HeartRate}; margin-right: 8px;">&nbsp;</span>${s.data.value} bpm`;
            else if (s.seriesName === "Calories") htmlTooltip += `<span style="background-color: ${CHART_COLOR_OPTION.Calories}; margin-right: 8px;">&nbsp;</span>${s.data.value} calories`;
          }
          return htmlTooltip;
        }
      };
    }
    option.series[0].name = chartTitle;
    option.series[0].itemStyle.color = chartColor;
    option.series[0].data = data.map((item, index) => {
      return { value: item[chartKeyData] };
    });

    return option;
  };
  
  return (
    <ReactEcharts
      option={buildChart(chartData) || {}}
      style={{ height: chartHeight ? chartHeight: "150px" }}
    />
  );
};

export default BarChart;
